export default __webpack_public_path__ + "static/media/report_center-hover.e25ba828.svg";